import './index.styl';
import template from './index.jst';
import { Model } from 'backbone';
import { View } from 'backbone.marionette';
import { Ladder } from '../../../collections';
import Radio from "backbone.radio";
import _ from 'lodash';

const tippingChannel = Radio.channel('tipping');

export default class WidgetLadder extends View {
	constructor(options) {
		super({
			model: new Model(),
			collection: new Ladder(),
			...options
		});
	}

	get className() {
		return 'widget-ladder';
	}

	get template() {
		return template;
	}

	initialize() {
		this.model.set({ ladder: [] });

		this.listenTo(this.collection, 'sync', this.convertData);
		this.listenTo(this.model, 'change', this.render);

		this.listenTo(tippingChannel, 'add:highlight:squads', this.addHighlight);
		this.listenTo(tippingChannel, 'remove:highlight:squads', this.removeHighlight);

		this.collection.fetch();
	}

	addHighlight(arr_squads) {
		const ladder = this.model.get('ladder');

		_.each(ladder, squad => {
			if(arr_squads.includes(squad.id)){
				squad.is_highlighted = true;
			}
		});

		this.model.set({ ladder });
		this.model.trigger('change');
	}

	removeHighlight() {
		const ladder = this.model.get('ladder');

		_.each(ladder, squad => {
			squad.is_highlighted = false;
		});

		this.model.set({ ladder });
		this.model.trigger('change');
	}

	convertData() {
		this.model.set({
			ladder: this.collection.toJSON().map(squad => ({
				...squad,
				is_highlighted: false,
				avatar_url: `${process.env.SQUAD_LOGOS_PATH + squad.id}.png`
			}))
		});
	}
}